'use client';

import './styles/default.scss';
import { classes } from '@/utils/classes/classes';

type SpinnerProps = {
    isBlack?: boolean;
};

export const Spinner = ({ isBlack }: SpinnerProps) => {
    return <div className={classes('spinner', isBlack && 'black')} />;
};
